import { Component, OnInit } from '@angular/core';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';
import { MarkdownComponent } from 'ngx-markdown';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cookies-policy',
  imports: [MarkdownComponent, RouterLink],
  templateUrl: './cookies-policy.html',
  styleUrl: './cookies-policy.scss',
})
export class CookiesPolicy implements OnInit {

    permissionService: PermissionService;

    constructor(permissionService: PermissionService) {
        this.permissionService = permissionService;
    }

    ngOnInit(): void {
        this.permissionService.acceptCookies();
        // Initialization logic if needed
    }
}
